export default {
  trackingActivity: {
    order: "รายการ",
    job: "งาน",
    shipment: "พัสดุ",
    activityTracking: "ติดตามสถานะกิจกรรม",
    search: "ค้นหา",
    orderNo: "เลขที่รายการ",
    companyTaxId: "เลขประจำตัวผู้เสียภาษีอากร",
    customerName: "ชื่อลูกค้า",
    status: "สถานะ",
    dateTime: "วันและเวลา",
    updateDatetime: "วันและเวลาที่มีการอัพเดท",
    createDatetime: "วันและเวลาที่สร้าง",
    createBy: "สร้างโดย",
    targetPickUpDatetime: "วันและเวลาที่คาดการณ์เข้ารับสินค้า",
    targetDeliveryDatetime: "วันและเวลาที่คาดการณ์ไปส่งสินค้า",
    paymentType: "ประเภทการชำระเงิน",
    presetLine: "กำหนดเส้นทาง",
    actualMileage: "ระยะทางตามจริง",
    upstreamTracking: "ติดตามต้นทาง",
    paymentChannel: "ช่องทางการชำระเงิน",
    orderPrice: "ราคา",
    action: "ดำเนินการ",
    submit: "ส่ง",
    confirm: "ยืนยัน",
    cancel: "ยกเลิก",
    tracking: "ติดตามสถานะ",
    viewMap: "ดูแผนที่",
    assignToDriver: "มอบหมายงานให้คนขับ",
    parentJob: "งานที่เกี่ยวข้อง",
    parentOrder: "รายการที่เกี่ยวข้อง",
    phoneNumber: "เบอร์โทรศัพท์",
    vehicleType: "ประเภทยานพาหนะ",
    licensePlate: "ทะเบียน",
    temperature: "อุณหภูมิ",
    temperatureType: "ประเภทอุณหภูมิ",
    temperatureRange: "ช่วงอุณหภูมิ",
    shipperName: "ชื่อผู้จัดส่ง",
    package: "จำนวนบรรจุภัณฑ์",
    volume: "ปริมาตร",
    packageboxes: "บรรจุภัณฑ์/กล่อง",
    quantity: "จำนวนสินค้า/บรรจุภัณฑ์",
    weight: "น้ำหนัก",
    cubicMeter: "ลูกบาศก์เมตร",
    pickUpDetail: "ข้อมูลขาเข้ารับสินค้า",
    cargoInformation: "ข้อมูลสินค้า",
    targetPickUpDate: "วันและเวลาที่คาดการณ์เข้ารับสินค้า",
    actualPickUpDate: "วันและเวลาที่เข้ารับสินค้าจริง",
    pickUpLocation: "สถานที่เข้ารับสินค้า",
    deliveryDetail: "ข้อมูลขาไปส่งสินค้า",
    actualDeliveryDateTime: "วันและเวลาที่ไปส่งสินค้าจริง",
    deliveryLocation: "สถานที่ไปส่งสินค้า",
    reassign: "มอบหมายงานใหม่",
    damage: "เสียหาย",
    lost: "สูญหาย",
    haventAssignedToDriver: "ยังไม่มีคนขับผู้รับผิดชอบ",
    orderList: "รายการที่เกี่ยวข้อง",
    jobList: "งานที่เกี่ยวข้อง",
    shipmentList: "พัสดุที่เกี่ยวข้อง",
    actionBy: "ดำเนินการโดย",
    actionByAdmin: "ดำเนินการโดย แอดมิน",
    actionByDriver: "ดำเนินการโดย คนขับ",
    updateStatus: "อัพเดตสถานะ",
    reassignShipment: "จัดพัสดุใหม่",
    reassignOrder: "จัดรายการใหม่",
    reassignJob: "จัดงานใหม่",
    cancelShipment: "ยกเลิกพัสดุ",
    cancelJob: "ยกเลิกงาน",
    cancelOrder: "ยกเลิกรายการ",
    setOrderAsALost: "อัพเดทสถานะรายการสูญหาย",
    setJobAsALost: "อัพเดทสถานะงานสูญหาย",
    setShipmentAsALost: "อัพเดทสถานะพัสดุสูญหาย",
    setShipmentAsADamage: "อัพเดทสถานะพัสดุเสียหาย",
    setOrderAsADamage: "อัพเดทสถานะรายการเสียหาย",
    setJobAsADamage: "อัพเดทสถานะงานเสียหาย",
    jobNumber: "เลขที่งาน",
    noOfShipments: "จำนวนพัสดุ",
    bu: "BU",
    orderNumber: "เลขที่รายการ",
    shipmentNumber: "เลขที่พัสดุ",
    subcontractorTaxId: "เลขประจำตัวผู้เสียภาษีอากรของผู้รับเหมา",
    subocontractorName: "ชื่อผู้รับเหมา",
    createDateTime: "ชื่อผู้รับเหมา",
    areYouSureYouWantToCancelOrder: "คุณยืนยันที่จะยกเลิกรายการนี้ใช่หรือไม่",
    areYouSureYouWantToCancelJob: "คุณยืนยันที่จะยกเลิกงานนี้ใช่หรือไม่",
    areYouSureYouWantToCancelShipment: "คุณยืนยันที่จะยกเลิกพัสดุนี้ใช่หรือไม่",
    areYouSureYouWantToUpdateDriverForTheShipment:
      "คุณยืนยันที่จะอัพเดทสถานะคนขับไปยังขั้นตอนถัดไปใช่หรือไม่",
    areYouSureYouWantToUpdateDriverForTheOrder:
      "คุณยืนยันที่จะอัพเดทสถานะคนขับไปยังขั้นตอนถัดไปใช่หรือไม่",
    areYouSureYouWantToUpdateDriverForTheJob:
      "คุณยืนยันที่จะอัพเดทสถานะคนขับไปยังขั้นตอนถัดไปใช่หรือไม่",
    areYouSureYouWantToReassignTheShipment:
      "คุณยืนยันที่จะยกเลิกรายการนี้ใช่หรือไม่",
    areYouSureYouWantToReassignTheOrder: "คุณยืนยันที่จะยกเลิกงานนี้ใช่หรือไม่",
    areYouSureYouWantToReassignTheJob:
      "คุณยืนยันที่จะมอบหมายงานนี้ใหม่ใช่หรือไม่",
    areYouSureYouWantToSetOrderStatusAsLost:
      'คุณยืนยันที่จะอัพเดทสถานะรายการนี้เป็น "สูญหาย" ใช่หรือไม่',
    areYouSureYouWantToSetShipmentStatusAsLost:
      'คุณยืนยันที่จะอัพเดทสถานะพัสดุนี้เป็น "สูญหาย" ใช่หรือไม่',
    areYouSureYouWantToSetJobStatusAsLost:
      'คุณยืนยันที่จะอัพเดทสถานะงานนี้เป็น "สูญหาย" ใช่หรือไม่',
    areYouSureYouWantToSetOrderStatusAsDamage:
      'คุณยืนยันที่จะอัพเดทสถานะรายการนี้เป็น "เสียหาย" ใช่หรือไม่',
    areYouSureYouWantToSetShipmentStatusAsDamage:
      'คุณยืนยันที่จะอัพเดทสถานะพัสดุนี้เป็น "เสียหาย" ใช่หรือไม่',
    areYouSureYouWantToSetJobStatusAsDamage:
      'คุณยืนยันที่จะอัพเดทสถานะงานนี้เป็น "เสียหาย" ใช่หรือไม่',

    cannotChangeStatus: "ไม่สามารถเปลี่ยนสถานะได้ กรุณารีเฟรชใหม่อีกครั้ง",
    driverHaveBeenUpdated: "อัพเดทสถานะของคนขับสำเร็จ",
    jobHaveBeenCancelled: "งานนี้ได้ถูกยกเลิกสำเร็จ",
    shipmentHaveBeenCancelled: "พัสดุนี้ได้ถูกยกเลิกสำเร็จ",
    orderHaveBeenCancelled: "รายการนี้ได้ถูกยกเลิกสำเร็จ",
    orderHaveBeenReassigned: "จัดรายการใหม่สำเร็จ",
    jobHaveBeenReassigned: "จัดการงานใหม่สำเร็จ",
    shipmentHaveBeenReassigned: "จัดการพัสดุใหม่สำเร็จ",
    jobHaveBeenSetAsALost: "อัพเดทงานที่สูญหายสำเร็จ",
    shipmentHaveBeenSetAsALost: "อัพเดทพัสดุสูญหายสำเร็จ",
    orderHaveBeenSetAsALost: "รายการมีการอัพเดทการสูญหายสำเร็จ",
    jobHaveBeenSetAsADamage: "อัพเดทงานที่เสียหายสำเร็จ",
    shipmentHaveBeenSetAsADamage: "อัพเดทพัสดุที่เสียหายสำเร็จ",
    orderHaveBeenSetAsADamage: "อัพเดทรายการที่เสียหายสำเร็จ",
    palletsboxs: "บรรจุภัณฑ์/กล่อง",
    pieces: "ชิ้น",
    cube: "ปริมาตร",
    kg: "กิโลกรัม",
    filter: "กรอง",
    pickUpDateTime: "วันและเวลาที่เข้ารับสินค้า",
    deliveryDateTime: "วันและเวลาที่ไปส่งสินค้า",
    total: "ทั้งหมด",
    startDateTime: "วันและเวลาที่เริ่ม",
    endDateTime: "วันและเวลาที่เสร็จสิ้น",
    allStatus: "สถานะทั้งหมด",
    all: "ทั้งหมด",
    resetFilter: "รีเซ็ตกรอง",
    startDate: "วันที่เริ่ม",
    endDate: "วันที่เสร็จสิ้น",
    reason: "เหตุผล",
    remark: "สังเกต",
    noData: "ไม่พบข้อมูล",
    viewAllPOD: "ดู POD ทั้งหมด",
    allPOD: "POD ทั้งหมด",
    pickUpPOD: "POD การเข้ารับสินค้า",
    deliveryPOD: "POD การส่งสินค้า",
    damagedPOD: "POD สินค้าเสียหาย",
    lostPOD: "POD สินค้าสูญหาย",
    returnPOD: "POD การคืนสินค้า",
    actualPickup: "การเข้ารับของตามจริง",
    goodsTemperature: "อุณหภูมิสินค้า",
    pickupWeight: "น้ำหนักตอนรับสินค้า",
    actualVolume: "ปริมาตรจริง",
    actualDelivery: "การส่งสินค้าจริง",
    offSiteSignOff: "นอกพื้นที่ไซต์",
    wrongAddress: "ที่อยู่ไม่ถูกต้อง",
    inaccuratePosition: "ที่อยู่ไม่แม่นยำ",
    correctAddress: "ที่อยู่ถูกต้อง",
    currentStatus: "สถานะปัจจุบัน",
    actualProcessTime: "เวลาที่ดำเนินการ",
    updateTime: "เวลาอัพเดต",
    updateBy: "อัพเดตโดย",
    updateTo: "สถานะถัดไป",
    skipBy: "ข้ามโดย",
    detail: "รายละเอียด",
    skipped: "ข้าม",
    enterDetailsToSetStatus: "กรอกรายละเอียดของสถานะทั้งหมดเพื่อตั้งค่าสถานะ",
    arriveOriginDateTime: "วันและเวลาที่ถึงต้นทาง",
    readyToLoadDateTime: "วันและเวลาที่พร้อมโหลดขึ้น",
    skipStatus: "ข้ามสถานะนี้",
    loadingDateTime: "วันและเวลาที่โหลดสินค้าขึ้น",
    onTheWayDateTime: "วันและเวลาที่เริ่มจัดส่ง",
    goodTemp: "อุณหภูมิสินค้า (C)",
    enterTemp: "กรอกอุณหภูมิสินค้า",
    deliverWeight: "น้ำหนักตอนส่งสินค้า",
    deliverWeightKg: "น้ำหนักตอนส่งสินค้า (กก.)",
    enterDeliverWeight: "กรอกน้ำหนักตอนส่งสินค้า",
    actualNoOfPackage: "จำนวนบรรจุภัณฑ์ตามจริง",
    enterActualNoOfPackage: "กรอกจำนวนบรรจุภัณฑ์ตามจริง",
    actualNoOfItemPerPackage: "จำนวนสินค้า/บรรจุภัณฑ์ตามจริง",
    enterActualNoOfItemPerPackage: "กรอกจำนวนสินค้า/บรรจุภัณฑ์ตามจริง",
    pickedUpWeightKg: "น้ำหนักตอนรับสินค้า (กก.)",
    enterPickedUpWeight: "กรอกน้ำหนักตอนรับสินค้า",
    actualVolumeCM: "ปริมาตรจริง (คิวบิกเมตร)",
    enterActualVolume: "กรอกปริมาตรจริง",
    arrivalDestinationDateTime: "วันและเวลาที่ถึงคลังปลายทาง",
    readyToUnloadDateTime: "วันและเวลาที่พร้อมโหลดลง",
    unloadingDateTime: "วันและเวลาที่โหลดสินค้าลง",
    deliverDateTime: "วันและเวลาที่ส่งสำเร็จ",
    deliveredDateTime: "วันและเวลาที่ส่งสำเร็จ",
    fieldDateGreaterThanPrevious: "{x} ต้องใหม่กว่าวันและเวลาของสถานะก่อนหน้า",
    invalidFieldName: "{field}ไม่ถูกต้อง",
    damagedDateTime: "วันและเวลาที่สินค้าเสียหาย",
    lostDateTime: "วันและเวลาที่สินค้าสูญหาย",
    pendingDeliveryFailDateTime: "วันและเวลาที่รอยืนยันส่งสินค้าไม่สำเร็จ",
    destination: "ปลายทาง",
    address: "ที่อยู่",
    optionAfterSetStatus: "ตัวเลือกหลังจากตั้งสถานะ",
    setStatusName: "ตั้งค่าสถานะเป็น {name}",
    changeDestination: "เปลี่ยนปลายทาง",
    pickupFailedDateTime: "วันและเวลาที่รับสินค้าไม่สำเร็จ",
    reAssignDriver: "มอบหมายคนขับใหม่",
    returnOnthewayDateTime: "วันและเวลาที่ระหว่างนำคืน",
    returnArriveDateTime: "วันและเวลาที่ถึงคลังคืนสินค้า",
    returnUnloadingDateTime: "วันและเวลาที่โหลดสินค้าคืนลง",
    returnedDateTime: "วันเวลาที่คืนสินค้า",
    returnWeightKg: "น้ำหนักตอนคืนสินค้า (กก.)",
    enterReturnWeight: "น้ำหนักตอนคืนสินค้า (กก.)",
    shipmentReturnTemp: "อุณหภูมิตอนคืนสินค้า (C)",
    sureUpdateStatus:
      "คุณแน่ใจหรือไม่ว่าต้องการอัพเดตสถานะพัสดุ <b>{shipmentNo}</b>",
    updateStatusSuccess: "อัพเดตสถานะเรียบร้อยแล้ว",
    quitUpdateStatus: "ออกจากการอัพเดตสถานะ",
    sureQuitStatus:
      "คุณแน่ใจหรือไม่ว่าต้องการออกจากอัพเดตสถานะพัสดุ การเปลี่ยนแปลงทั้งหมดที่คุณทำจะไม่ถูกบันทึก",
    moreDetail: "รายละเอียดเพิ่มเติม",
    returnDetail: "รายละเอียดการคืนสินค้า",
    actualReturn: "การคืนสินค้าตามจริง",
    returnLocation: "สถานที่คืนสินค้า",
    locationOnGoogleMap: "ตำแหน่งที่ตั้งบน Google Map",
    returnDateTime: "วันเวลาที่คืนสินค้า",
    actualReturnDateTime: "วันเวลาที่คืนสินค้าตามจริง",
    trackingDetail: "รายละเอียดติดตามสถานะ",
    statusDetail: "รายละเอียดสถานะ",
    shipmentPickupTemperature: "อุณหภูมิสินค้าตอนรับ",
    shipmentDeliverTemperature: "อุณหภูมิสินค้าตอนส่ง",
    shipmentReturnTemperature: "อุณหภูมิตอนคืนสินค้า",
    enterPaymentChannel: "กรอกช่องทางการชำระเงิน",
    enterActualOrderPrice: "กรอกราคาจริง",
    enterActualCurrency: "กรอกสุกลเงินจริง",
    viewAllCargoList: "ดูรายการสินค้าทั้งหมด",
    cargoList: "รายการสินค้า",
    job_document: "เอกสารงาน",
    documentation: "เอกสาร",
    readiness_check: "ตรวจสอบความพร้อม",

    // ACTIVITY_TRACKING_ORDER_STATUSES
    order_created: "คำสั่งซื้อ_สร้าง",
    order_confirmed: "คำสั่งซื้อ_ยืนยัน",
    order_processing: "คำสั่งซื้อ_ดำเนินการ",
    order_picking_up: "คำสั่งซื้อ_กำลังรับสินค้า",
    order_ontheway: "คำสั่งซื้อ_ระหว่างจัดส่ง",
    order_delivered: "คำสั่งซื้อ_ส่งสำเร็จ",
    order_delivery_failed: "คำสั่งซื้อ_ส่งสินค้าไม่สำเร็จ",
    order_approved: "คำสั่งซื้อ_ยืนยันสำเร็จ",
    order_cancelled: "คำสั่งซื้อ_ยกเลิก",
    order_pickup_failed: "คำสั่งซื้อ_รับสินค้าไม่สำเร็จ",
    order_pending_delivery_fail: "คำสั่งซื้อ_รอยืนยันส่งสินค้าไม่สำเร็จ",
    order_returned: "คำสั่งซื้อ_คืนสำเร็จ",
    order_damaged: "คำสั่งซื้อ_สินค้าเสียหาย",
    order_lost: "คำสั่งซื้อ_สินค้าสูญหาย",

    // ACTIVITY_TRACKING_JOB_STATUSES
    job_created: "งาน_สร้าง",
    job_planned: "งาน_วางแผน",
    job_accepted: "งาน_รับงาน",
    job_arrive_origin: "งาน_ถึงคลังต้นทาง",
    job_picking_up: "งาน_กำลังรับสินค้า",
    job_ontheway: "งาน_ระหว่างจัดส่ง",
    job_arrive_destination: "งาน_ถึงคลังปลายทาง",
    job_handing_over: "งาน_กำลังส่งสินค้า",
    job_delivered: "งาน_ส่งสำเร็จ",
    job_approved: "งาน_ยืนยันสำเร็จ",
    job_cancelled: "งาน_ยกเลิก",
    job_pickup_failed: "งาน_รับสินค้าไม่สำเร็จ",
    job_pending_delivery_fail: "งาน_รอยืนยันส่งสินค้าไม่สำเร็จ",
    job_delivery_failed: "งาน_ส่งสินค้าไม่สำเร็จ",
    job_approved_return: "งาน_ยืนยันคืนสินค้า",
    job_returned: "งาน_คืนสำเร็จ",
    job_damaged: "งาน_สินค้าเสียหาย",
    job_lost: "งาน_สินค้าสูญหาย",

    // ACTIVITY_TRACKING_SHIPMENT_STATUSES
    shipment_created: "สินค้า_สร้าง",
    shipment_processing: "สินค้า_ดำเนินการ",
    shipment_dispatched: "สินค้า_รับงาน",
    shipment_arrive_origin: "สินค้า_ถึงคลังต้นทาง",
    shipment_ready_to_load: "สินค้า_พร้อมโหลดขึ้น",
    shipment_loading: "สินค้า_โหลดสินค้าขึ้น",
    shipment_ontheway: "สินค้า_ระหว่างจัดส่ง",
    shipment_arrive_destination: "สินค้า_ถึงคลังปลายทาง",
    shipment_ready_to_unload: "สินค้า_พร้อมโหลดลง",
    shipment_unloading: "สินค้า_โหลดสินค้าลง",
    shipment_delivered: "สินค้า_ส่งสำเร็จ",
    shipment_approved: "สินค้า_ยืนยันสำเร็จ",
    shipment_cancelled: "สินค้า_ยกเลิก",
    shipment_pickup_failed: "สินค้า_รับสินค้าไม่สำเร็จ",
    shipment_pending_delivery_fail: "สินค้า_รอยืนยันส่งสินค้าไม่สำเร็จ",
    shipment_delivery_failed: "สินค้า_ส่งสินค้าไม่สำเร็จ",
    shipment_approved_return: "สินค้า_ยืนยันคืนสินค้า",
    shipment_return_ontheway: "สินค้า_ระหว่างนำคืน",
    shipment_return_arrive: "สินค้า_ถึงคลังคืนสินค้า",
    shipment_return_unloading: "สินค้า_โหลดสินค้าคืนลง",
    shipment_returned: "สินค้า_คืนสำเร็จ",
    shipment_damaged: "สินค้า_สินค้าเสียหาย",
    shipment_lost: "สินค้า_สินค้าสูญหาย",

    // Driver
    driver: "คนขับรถ",
    hide: "ซ่อน",
    viewAll: "ดูทั้งหมด",
    job: "งาน",

    //Driver Time
    driverTime: "เวลาการขับ",
    durationHrs: "ระยะเวลา (ชม.)",
    driverActionType: "ประเภทกิจกรรม",
    driverStartTime: "เวลาเริ่ม",
    driverEndTime: "เวลาจบ",
    driverActionTypeTravel: "เดินทาง",
  },
};



// WEBPACK FOOTER //
// ./src/lang/th/pages/tracking-activity/trackingActivity.js